import React, { createContext, useContext, useState, useEffect } from "react";
import api from "../api/axios";
import toast from "react-hot-toast";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const saved = localStorage.getItem("user");
    return saved ? JSON.parse(saved) : null;
  });
  const [loading, setLoading] = useState(false);

  // Validate token on mount
  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (token && !user) {
      api.get("/auth/me")
        .then(({ data }) => {
          setUser(data.data.user);
          localStorage.setItem("user", JSON.stringify(data.data.user));
        })
        .catch(() => {
          localStorage.removeItem("accessToken");
          localStorage.removeItem("user");
        });
    }
  }, []);

  const register = async ({ name, email, password, phone }) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", { name, email, password, phone });
      localStorage.setItem("accessToken", data.data.accessToken);
      localStorage.setItem("user", JSON.stringify(data.data.user));
      setUser(data.data.user);
      toast.success("Welcome to Sanjivani Ayurveda! 🌿");
      return { success: true };
    } catch (err) {
      const msg = err.response?.data?.message || "Registration failed";
      toast.error(msg);
      return { success: false, message: msg };
    } finally {
      setLoading(false);
    }
  };

  const login = async ({ email, password }) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("accessToken", data.data.accessToken);
      localStorage.setItem("user", JSON.stringify(data.data.user));
      setUser(data.data.user);
      toast.success("Welcome back! 🌿");
      return { success: true, user: data.data.user };
    } catch (err) {
      const msg = err.response?.data?.message || "Login failed";
      toast.error(msg);
      return { success: false, message: msg };
    } finally {
      setLoading(false);
    }
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (_) {}
    localStorage.removeItem("accessToken");
    localStorage.removeItem("user");
    setUser(null);
    toast.success("Logged out successfully");
  };

  return (
    <AuthContext.Provider value={{ user, loading, register, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);